module.exports = __webpack_public_path__ + "svg/DocBox.5b1b0d6.svg";